import React, { Component } from 'react'

export default class Component1 extends Component {
  render() {
    return (
      <div>This class is Open Source Studio in HGU!!</div>
    )
  }
}
